<template>

  <div id="app">

    <!-- Header -->
    <div class="col-12 bg-header">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-2 text-center">
            <img src="https://www.rueden.de/images/Logo-Horizontal-inversion.png" alt="VON RUEDEN"/>
          </div>
          <div class="col-12 col-md-8 text-center">
            <h1>Arbeitsrecht - Aufhebungsvertrag</h1>
          </div>
        </div>
      </div>
    </div>

    <!-- Upload in Progress -->
    <div v-if="uploadInProgress" class="upload-progress">
      <div class="spinner-border" role="status">
        <span class="sr-only">Lade ...</span>
      </div>
      <h2>Bitte warten. Dokument wird hochgeladen.</h2>
    </div>

    <!-- Payment in Progress -->
    <div v-if="payment_in_progress" class="upload-progress">
      <div class="spinner-border" role="status">
        <span class="sr-only">Lade ...</span>
      </div>
      <h2>Bitte warten. Zahlung wird durchgeführt.</h2>
    </div>

    <div v-if="!rechnung_bezahlt">

      <div class="container mt-4">

        <div class="row">
          <div class="col-lg-12">

            <div class="border bg-white p-4" style="box-shadow: 0 0 25px rgba(0,0,0,0.1);">

              <!-- if !submitted -->
              <form class="mb-4" id="rechnungsadresse" @change="submitRechnungsadresse">

                <input type="hidden" name="token" id="session_token" v-model="token" />

                <p v-if="rechnungsadresse_vorhanden" class="lead font-weight-bold text-primary">1. Anschrift <i class="fa fa-check-circle text-success"></i></p>
                <p v-else class="lead font-weight-bold text-primary">1. Anschrift</p>

                <div class="alert alert-light p-0">

                  <div class="row">

                    <div class="col-xl-4 mb-xl-0 col-lg-4 col-md-6 mb-3">
                      <div class="visible">
                        <div class="form-group">
                          <label>Anrede</label>
                          <div>
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="stammdaten[anrede]" value="Herr" id="anrede_1" v-model="stammdaten.anrede" required>
                              <label class="form-check-label" for="anrede_1">Herr</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="stammdaten[anrede]" value="Frau" id="anrede_2" v-model="stammdaten.anrede" required>
                              <label class="form-check-label" for="anrede_2">Frau</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-4 mb-xl-0 col-lg-4 col-md-6 mb-3">
                      <div class="visible">
                        <div class="form-group">
                          <label>Vorname</label>
                          <input
                              type="text"
                              name="stammdaten[vorname]"
                              id="vorname"
                              class="form-control"
                              v-model="stammdaten.vorname"
                              required/>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-4 mb-xl-0 col-lg-4 col-md-6 mb-3">
                      <div class="visible">
                        <div class="form-group">
                          <label>Nachname</label>
                          <input
                              type="text"
                              name="stammdaten[nachname]"
                              id="nachname"
                              class="form-control"
                              v-model="stammdaten.nachname"
                              required/>
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-4 mb-xl-0 col-lg-4 col-md-6 mb-3">
                      <div class="visible">
                        <div class="form-group">
                          <label>Straße und Nr.</label>
                          <input
                              type="text"
                              name="stammdaten[strasse]"
                              id="strasse"
                              class="form-control"
                              v-model="stammdaten.strasse"
                              required/>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-4 mb-xl-0 col-lg-4 col-md-6 mb-3">
                      <div class="visible">
                        <div class="form-group">
                          <label>Postleitzahl</label>
                          <input
                              type="text"
                              name="stammdaten[plz]"
                              id="plz"
                              class="form-control"
                              v-model="stammdaten.plz"
                              required/>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-4 mb-xl-0 col-lg-4 col-md-6 mb-3">
                      <div class="visible">
                        <div class="form-group">
                          <label>Ort</label>
                          <input
                              type="text"
                              name="stammdaten[ort]"
                              id="ort"
                              class="form-control"
                              v-model="stammdaten.ort"
                              required/>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

                <div class="alert alert-light p-0">

                  <div class="row">
                    <div class="col-12 mb-xl-0">
                      <div class="visible">
                        <table class="table-sm table-borderless mb-0">
                          <tbody>
                          <tr class="align-top">
                            <td><input type="checkbox" id="zustimmung_datenschutz" required/></td>
                            <td>

                              <label style="display:inline" for="zustimmung_datenschutz">
                                Ich habe die <a class="font-weight-bold" href="https://www.rueden.de/datenschutzerklaerung" target="_blank">
                                <u>Datenschutzerklärung</u></a> und die
                                <a class="font-weight-bold" href="https://www.rueden.de/widerrufsbelehrung" target="_blank">
                                  <u>Widerrufsbelehrung</u></a> gelesen und bin damit einverstanden.
                              </label>

                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="row">
                  <div class="col-lg-12">
                    <hr />

                    <p v-if="aufhebungsvertrag_vorhanden" class="lead font-weight-bold text-primary">2. Aufhebungsvertrag hochladen <i class="fa fa-check-circle text-success"></i></p>
                    <p v-else class="lead font-weight-bold text-primary">2. Aufhebungsvertrag hochladen</p>

                    <div class="row mt-4">
                      <!-- Upload-Felder -->
                      <div class="col-lg-6 mb-2" v-for="(index, item) in files" :key="item">
                        <div class="" style="">
                          <div class="visible">

                            <div class="btn-group">
                            <button type="button" class="btn btn-outline-primary" @click="openFileDialog(item)">
                              {{ tags[item] }} auswählen
                            </button>
                              <button :class="{'disabled':files[item].length < 1}" @click="uploadFiles()" type="button" class="btn btn-primary">
                                <i class="fa fa-upload"></i>
                                Übermitteln
                            </button>
                              </div>

                            <input @change="addFilesToList(item)" type="file" multiple class="d-none" :name="item" :id="item"/>
                          </div>
                          <div class="border-1 mt-2">
                            <div v-if="uploadFinished[item] && files[item].length === 0">
                              <i class="fa fa-check-circle text-success"></i> Alle Dateien erfolgreich übermittelt
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Bezahlung -->
                      <div class="container">
                        <hr />
                        <div class="row">
                          <div class="col-lg-6">
                            <p class="lead font-weight-bold text-primary">3. Zahlung</p>

                            <p v-if="!rechnung_bezahlt && aufhebungsvertrag_vorhanden && rechnungsadresse_vorhanden">
                              Ihre Daten und Dokumente sind vollständig. Bitte klicken Sie auf den "Direkt zu PayPal"-Button
                              um auf die Bezahlmaske weitergeleitet zu werden. Sie haben die Auswahl zwischen verschiedenen
                              Zahlungsmöglichkeiten.</p>

                            <p v-if="!rechnung_bezahlt && (!aufhebungsvertrag_vorhanden || !rechnungsadresse_vorhanden)">
                              Bitte vervollständigen Sie Schritt 1. und 2. um die Bezahlung durchzuführen.</p>

                            <p v-if="rechnung_bezahlt">
                              Sie haben die Zahlung bereits durchgeführt. Vielen Dank, wird werden uns zeitnah mit Ihnen in Verbindung setzen.
                            </p>

                            </div>
                          <div class="col-lg-6 pt-4">
                            <PayPal
                                v-if="rechnungsadresse_vorhanden && aufhebungsvertrag_vorhanden && !rechnung_bezahlt"
                                env="production"
                                :button-style="myStyle"
                                amount="249.00"
                                currency="EUR"
                                :items="myItems"
                                v-on:payment-authorized="authorized"
                                v-on:payment-complete="completed"
                                v-on:payment-cancelled="abbruch"
                                :experience="experienceOptions"
                                :client="credentials"
                                :cancelUrl="'https://www.rueden.de'"
                            >
                            </PayPal>

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </form>
              <!-- VM ENDE -->

            </div>

          </div>
        </div>

      </div>

    </div>

    <div v-else>
      <div class="container text-center py-5">
        <h1>Vielen Dank</h1>
        <p class="lead">Wir haben Ihre Zahlung erhalten und werden Sie zeitnah kontaktieren.</p>
      </div>
    </div>

    <div class="text-center mb-3">
      <div class="small mt-3"><i class="fa fa-lock text-warning"></i> Sichere Datenübertragung dank
        SSL-Verschlüsselung.
      </div>
    </div>

    <!-- Modals -->
    <HinweisAbrechnung />
    <b-modal id="modal-hinweis-widerruf" title="Information" :ok-only="true" :ok-title="'schließen'">
      <p>In Einzelfällen muss binnen einer Woche reagiert werden, um die Kündigung unwirksam zu machen. Zudem gilt immer
        eine lediglich dreiwöchige Kündigungsfrist ab Zugang der Kündigung.</p>
      <p>Bei Fragen kontaktieren Sie uns gerne vorab
        unter <a href="mailto:info@rueden.de">info@rueden.de</a>.</p>
    </b-modal>

  </div>

</template>
<script>

import PayPal from 'vue-paypal-checkout'
import axios from 'axios'
import HinweisAbrechnung from "@/views/HinweisAbrechnung";

export default {

  components: {
    HinweisAbrechnung,
    PayPal
  },

  data() {

    return {

      credentials: {
        sandbox: 'AWPNr33bnTTPheuATG7fKCno6L-9J6u5pe0gJYPD9wb-4-gVl7l_008mb5b7E1ghAgKxJIDcyTSTpJV4',
        production: 'AT5U2zFmJyQJ6OSiLv1eAVZaT3cLq6iJz_JuWqCuDQ5Lz5w4d877wE2x_ko7KKGdVlJn5AxN8vKueYq0'
      },

      experienceOptions: {
        input_fields: {
          no_shipping: 1,
        },
      },

      myItems: [
        {
          "name": "Beratungspaket Aufhebungsveträge",
          "description": "Beratungspaket Aufhebungsveträge",
          "quantity": "1",
          "price": "249.00",
          "currency": "EUR"
        }
      ],

      myStyle: {
        label: 'checkout',
        size:  'responsive',
        shape: 'rect',
        color: 'blue'
      },

      token: "",

      rechnungsadresse_vorhanden: false,
      aufhebungsvertrag_vorhanden: false,
      zahlung_erhalten: false,

      stammdaten: {
        anrede: "",
        vorname: "",
        nachname: "",
        strasse: "",
        plz: "",
        ort: "",
        session_token: ""
      },
      rechnung_bezahlt: 0,

      prozesskostenfinanzierung: false,

      falldaten: {
      },

      file: null,
      files: {
        aufhebungsvertrag: [],
      },

      tags: {
        aufhebungsvertrag: "Aufhebungsvertrag",
      },

      docType: null,

      uploadInProgress: false,
      uploadFinished: {
        aufhebungsvertrag: false,
      },

      payment_in_progress: false

    }
  },

  mounted() {

    document.title = 'Arbeitsrecht - Aufhebungsvertrag';
    this.$global.gaCat = 'Arbeitsrecht - Aufhebungsvertrag';

    // URL der API
    let token = this.$route.query.token;

    // API
    this.api = "https://flow.rueden.de/api/get/lead/" + token;

    if (token === '' || token === undefined) {
      window.location.href = "https://www.rueden.de";
    } else {
      this.token = token;
      this.stammdaten['session_token'] = token;
    }

    // Get Lead from Flow
    this.getLead();

  },
  methods: {

    authorized(data) {
      let token = this.token;
      this.payment_in_progress = true
      axios.post(
          'https://flow.rueden.de/api/post/payment',
          { token: token, leistung: 'Beratungsapket Aufhebungsvertrag', paypal_data: data},
          {headers: {'Content-Type': 'application/json'}})
          .then(() => {
            window.location.href = "/arbeitsrecht/aufhebungsvertrag?token=" + token
          })
      .catch(() => {
        window.location.href = "/arbeitsrecht/aufhebungsvertrag?token=" + token
      })
    },

    completed(data) {
      console.log("Komplett")
      console.log(data)
    },

    abbruch(data) {
      console.log("Abbruch")
      console.log(data)
    },

    openFileDialog(docType) {
      this.docType = docType;
      document.getElementById(docType).click();
    },

    addFilesToList(docType) {
      let _this = this;
      let selectedFiles = document.getElementById(docType).files;
      Array.prototype.forEach.call(selectedFiles, function (file) {
        _this.files[docType].push(file);
      });
    },

    uploadFiles() {

      let _this = this;

      // Nichts ausgewählt
      if (this.files.aufhebungsvertrag.length === 0) {
        alert('Bitte wählen Sie zunächst eine oder mehrere Dateien von Ihre Computer bzw. Smartphone zu hochladen aus.')
        return true;
      }

      for (let item in this.files) {

        if (this.files[item].length > 0) {

          this.uploadInProgress = true;
          let fileCountArrayIndex = this.files[item].length - 1;
          this.file = document.getElementById(item).files[fileCountArrayIndex];
          this.uploadInProgress = true;
          let formData = new FormData();
          formData.append('file', this.file);
          formData.append('token', this.token);
          formData.append('tag', this.tags[item]);
          formData.append('disable_emails', "true"); // Weißt die API an, keine Mails zu versenden

          axios.post('https://flow.rueden.de/api/import-files/arbeitsrecht', formData, {headers: {'Content-Type': 'multipart/form-data'}})
              .then(() => {
                _this.uploadInProgress = false;
              })
              .then(() => {
                _this.files[item].pop(); // Remove uploaded file from array
              })
              .then(() => {
                if (_this.files[item].length > 0) {
                  _this.uploadFiles(); // More files to upload? Upload!
                } else {
                  _this.uploadFinished[item] = true;
                }
                _this.aufhebungsvertrag_vorhanden = 1
              })
              .catch(function () {
                _this.uploadInProgress = false;
              });
        }

      }

    },

    getLead() {
      let url = 'https://flow.rueden.de/api/get/lead/'+this.token;

      let _this = this;
      axios.get(url)
          .then((response) => {
            let lead = response.data;
            _this.stammdaten.anrede = lead.anrede;
            _this.stammdaten.vorname = lead.vorname;
            _this.stammdaten.nachname = lead.nachname;
            _this.stammdaten.strasse = lead.strasse;
            _this.stammdaten.plz = lead.plz;
            _this.stammdaten.ort = lead.ort;
            _this.aufhebungsvertrag_vorhanden = lead.aufhebungsvertrag_vorhanden;
            _this.rechnung_bezahlt = lead.rechnung_bezahlt;
          })
    },

    checkRechnungsadresse() {
      // Validate Form
      let form = document.getElementById("rechnungsadresse");
      if (form.checkValidity()) {
        this.rechnungsadresse_vorhanden = true;
        this.submitRechnungsadresse()
      } else {
        this.rechnungsadresse_vorhanden = false;
      }
    },

    submitRechnungsadresse() {

      // Validate Form
      let form = document.getElementById("rechnungsadresse");
      if (form.checkValidity() === false) {
        this.rechnungsadresse_vorhanden = false;
        return false;
      } else {
        this.rechnungsadresse_vorhanden = true;
      }

      let _this = this;

      fetch("https://flow.rueden.de/api/update/lead", {
        method: 'POST',
        headers: { 'Content-Type' : 'application/json' },
        body:
            JSON.stringify({
              stammdaten: _this.stammdaten,
            })
      })
    },

  }

}


</script>

<style>
.pricing-table:hover {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.btn-primary-click {
  color: #003764;
  padding: 0.375rem 1.7rem;
  background: #b6db00 !important;
}

.btn-primary-click:hover,
a.btn-primary-click:hover {
  color: #fff !important;
  background: #638c1c !important;
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #2c3e50;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
